import * as types from './coverageGapToolEncoreActionType';

export const fetchCoverageGapToolEncorePowerBIReportRequest = () => ({
    type: types.FETCH_COVERAGE_GAP_TOOL_ENCORE_POWER_BI_REPORT_REQUEST
});
export const fetchCoverageGapToolEncorePowerBIReportSuccess = (data) => ({
    type: types.FETCH_COVERAGE_GAP_TOOL_ENCORE_POWER_BI_REPORT_SUCCESS,
    payload: data
});
export const fetchCoverageGapToolEncorePowerBIReportFailure = (error) => ({
    type: types.FETCH_COVERAGE_GAP_TOOL_ENCORE_POWER_BI_REPORT_FAILURE,
    payload: error
});

export const fetchCoverageGapToolEncoreLastRefreshedRequest = () => ({
    type: types.FETCH_COVERAGE_GAP_TOOL_ENCORE_LAST_REFRESHED_REQUEST
});
export const fetchCoverageGapToolEncoreLastRefreshedSuccess = (dateTime, nextRefreshDateTime = null, capacityTableReportName = null) => ({
    type: types.FETCH_COVERAGE_GAP_TOOL_ENCORE_LAST_REFRESHED_SUCCESS,
    payload: { lastRefreshedDateTime: dateTime, nextRefreshDateTime, capacityTableReportName }
});
export const fetchCoverageGapToolEncoreLastRefreshedFailure = (error) => ({
    type: types.FETCH_COVERAGE_GAP_TOOL_ENCORE_LAST_REFRESHED_FAILURE,
    payload: error
});
